import { Action } from "redux";

export const SET_GEOMETRY_CREATED = "SET_GEOMETRY_CREATED";

export interface GeometryChagedAction extends Action {}

export const setGeometryCreatedAction = (): GeometryChagedAction => ({
    type: SET_GEOMETRY_CREATED,
});
